'use strict';

import axios from 'axios';
import errorsLangEs from '@/common/lang/es/errors';
import errorsLangEn from '@/common/lang/en/errors';
import errorsLangAy from '@/common/lang/ay/errors';
import Auth from '@/components/admin/auth/mixins/auth';
import store from '@/store';
import router from '@/router';

const protocol = window.location.protocol.replace(':', '');
const PATERN_HOST = protocol === 'https' ? /(https:\/\/|www\.)\S+/i : /(http:\/\/|www\.)\S+/i;
const plantilla_html = `<!DOCTYPE html><html lang="en">  <head>    <meta charset="UTF-8" />    <meta http-equiv="X-UA-Compatible" content="IE=edge" />    <meta name="viewport" content="width=device-width, initial-scale=1.0" />    <style>      p,      a,      h1,      h2,      h3,      h4,      h5,      h6 {        font-family: "Century Gothic", sans-serif;      }      h1 {        font-size: 30px !important;      }      h2 {        font-size: 25px !important;      }      h3 {        font-size: 18px !important;      }      h4 {        font-size: 16px !important;      }      p,      a {        font-size: 15px !important;      }      .claseBoton {        width: 30%;        background-color: #140086;        border: 2px solid #3bbffc;        color: rgb(255, 255, 255);        padding: 16px 32px;        text-align: center;        text-decoration: none  !important;        font-weight: bold;        display: inline-block;        font-size: 16px;        margin: 4px 2px;        transition-duration: 0.4s;        cursor: pointer;      }      .claseBoton:hover {        background-color: #282463;        color: #ffffff;      }      .imag {        width: 20px;        height: 20px;      }      .contA {        margin: 0px 5px 0 5px;      }      .afooter {        color: #ffffff !important;        text-decoration: none  !important;        font-size: 13px !important;      }    </style>  </head>  <body>    <div style="width: 100%; background-color: #e3e3e3">      <div style="padding: 20px 10px 20px 10px">        <!-- Imagen inicial -->        <div          style="            background-color: #0e0227;            padding: 10px 0px 10px 0px;            width: 100%;            text-align: center;          "        >          <h1 style="color: white">SAP-RRHH</h1>        </div>        <!-- Imagen inicial -->        <!-- Contenido principal -->        <div          style="            background-color: #ffffff;            padding: 20px 0px 5px 0px;            width: 100%;            text-align: center;          "        >          {CONTENIDO}         <p style="margin-bottom: 50px"><i></i><br /></p>          <!-- Botón -->     <a title="Para ingresar al sistema haga click aqui"class="claseBoton" style="text-decoration: none !important" href="{URL_SISTEMA}">SISTEMA SAP</a>        </div>        <!-- Contenido principal -->        <!-- Footer -->        <div          style="            background-color: rgba(16, 1, 71, 0.8);            color: #ffffff;            padding: 5px 0px 0px 0px;            width: 100%;            text-align: center;          "        >          <h4>Soporte</h4>          <p style="font-size: 13px; padding: 0px 20px 0px 20px">            Comunícate con nosotros por los siguientes medios:<br />            Interno: <span class="afooter">${process.env.CONTACTO_REFERENCIA}</span><br />          </p>          <p            style="              background-color: #0e0227;              padding: 10px 0px 10px 0px;              font-size: 12px !important;            "          >            © ${new Date().getFullYear()} DOP-UTI          </p>        </div>        <!-- Footer -->      </div>    </div>  </body></html>`
export default {
  store,
  router,
  install: (Vue, config) => {
    // config
    const apiUrl = config && config.apiUrl ? config.apiUrl : '';
    const graphqlUrl = config && config.graphqlUrl ? config.graphqlUrl : '';
    const authUrl = config && config.authUrl ? config.authUrl : '';
    const authToken = config && config.authToken ? config.authToken : 'Bearer';

    // Plugins
    let instance = new Vue({
      mixins: [Auth]
    });
    const Util = instance.$util;
    const Message = instance.$message;
    const Storage = instance.$storage;
    const Loading = instance.$loading;

    const languages = {
      'es': errorsLangEs,
      'en': errorsLangEn,
      'ay': errorsLangAy
    };

    function t(key) {
      let lang = Storage.get('lang') || process.env.LANG;
      return languages[lang][key];
    }

    const Services = {
      options(url) {
        return _http('get', url + '/fields');
      },

      get(url, id) {
        return _http('get', url, id);
      },

      post(url, data) {
        return _http('post', url, data);
      },

      put(url, data) {
        return _http('put', url, data);
      },

      patch(url, data) {
        return _http('patch', url, data);
      },

      delete(url, id) {
        return _http('delete', url, id);
      },

      remove(url, id) {
        return this.delete(url, id);
      },

      list(url, query) {
        query = query ? '?' + Util.serialize(query) : '';
        return _http('get', url + query);
      },

      save(url, data) {
        return _http(data.id ? 'put' : 'post', url, data);
      },

      file(url, type, data = {}) {
        url = getUrl(url);
        return axios.post(url, data, { responseType: 'arraybuffer' })
          .then(response => {
            if (response.data) {
              let file = new window.Blob([response.data], { type: type });
              let fileURL = window.URL.createObjectURL(file);
              // return $sce.trustAsResourceUrl(fileURL);
              return fileURL;
            }
            return null;
          }).catch(error => handlingErrors(error));
      },

      pdf(url, data = {}, onlyUrl) {
        url = getUrl(url, data);
        return axios.post(url, data, { responseType: 'arraybuffer' })
          .then(response => {
            if (response.data) {
              let file = new window.Blob([response.data], { type: 'application/pdf' });
              let fileURL = window.URL.createObjectURL(file);
              // return onlyUrl ? fileURL : $sce.trustAsResourceUrl(fileURL);
              return fileURL;
            }
            return null;
          }).catch(error => handlingErrors(error));
      },

      graphql(data) {
        let setting = {
          method: 'post',
          url: graphqlUrl,
          data
        };

        // Set token in headers
        if (Storage.exist('token')) {
          setting.headers = { 'Authorization': `${authToken} ${Storage.get('token')}` };
        }
        instance.$Progress.start();
        return axios(setting)
          .then(response => {
            instance.$Progress.finish();
            Loading.hide();
            if (response.data.errors) {
              parseErrorGraphql(response.data);
            } else {
              return response.data.data;
            }
          })
          .catch(error => {
            instance.$Progress.finish();
            Loading.hide();
            if (error.response && error.response.data) {
              let data = error.response.data;
              parseErrorGraphql(data);
            }
          });
      },
      // LA MISMA CONSULTA SIN EL LOADING
      graphqlNotLoad(data) {
        let setting = {
          method: 'post',
          url: graphqlUrl,
          data
        };
        // Set token in headers
        if (Storage.exist('token')) {
          setting.headers = { 'Authorization': `${authToken} ${Storage.get('token')}` };
        }
        return axios(setting)
          .then(response => {

            if (response.data.errors) {
              parseErrorGraphql(response.data);
            } else {
              return response.data.data;
            }
          })
          .catch(error => {
            if (error.response && error.response.data) {
              let data = error.response.data;
              parseErrorGraphql(data);
            }
          });
      },
      //OBTENER ESTADO DE LA TABLA PŔOGRAMACION:
      async obtenerEstadoProgramación(p_gestion) {
        try {
          let resp = await this.graphql({
            query: `
                    query {
                      runQuery(consulta:"select p.id_estado from vacaciones.programacion p where p.id_estado not in (2,59) and p.gestion =${p_gestion}"){
                        respuesta
                      }
                    }
                  `
          });

          if (resp.runQuery.respuesta.length > 0) {
            let id_estado =
              resp.runQuery.respuesta[0].id_estado;
            return id_estado;
          }
        } catch (error) {
          console.log(error);
         // return false
        }
      },

      //Servicio para enviar correo
      async sendEmail(parametros) {
        let correos;

        // Si CORREO_REAL es true: Envio correos defecto
        if (!process.env.CORREO_REAL) {
          correos = process.env.CORREOS_PRUEBA.split(","); // correo
          Message.info("El correo deberia ser enviado a " + parametros.correo)
        }
        // Si CORREO_REAL es false: Envio correos reales
        else {
          correos = [parametros.correo];
        }
        // CONSTRUIMOS EL HTML
        //var ruta_sistema = process.env.API_URL.split("api/")[0]
        var ruta_sistema = "https://rrhhsiap.aspb.gob.bo/"
        let cadena_html = null
        if (parametros.html) {
          cadena_html = plantilla_html.replace(/{CONTENIDO}/g, parametros.html).replace(/{URL_SISTEMA}/g, ruta_sistema)
        }
        // {   // utf-8 string as an attachment
        //     filename: "PDF_prueba", // file name, like 'test.pdf'
        //     href: "http://172.20.253.116:8080/jasperserver/flow.html?_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&j_username=jasperadmin&j_password=jasperadmin&ParentFolderUri=%2Freports%2Fsioci%2Fprueba&reportUnit=/reports/sioci/prueba/rpt_formulario2&output=pdf&P_ID_INFORME_AREA_ORGANIZACIONAL=35" // link to the file, like http://example.com/invoices/test.pdf 
        // }
        try {
          for (let index = 0; index < correos.length; index++) {
            const email = correos[index];
            let body = {
              mail: email,
              asunto: parametros.asunto,
              message: parametros.mensaje,
              html: cadena_html,
            };
            const token = Storage.get('token');
            const url = `${process.env.API_URL}system/sendmail`;
            const options = {
              method: "POST",
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json"
              },
              body: JSON.stringify(body)
            };
            var data = await fetch(url, options);
            data = await data.json();
            if (data.mensaje == "Success") {
              Message.success("El correo de notificación fue enviado " + email);
              return true
            } else {
              Message.error(data.error || data.mensaje || data);
              return false
            }
          }
        } catch (error) {
          console.log(error);
          return false
        }
      },
      // Metodo para subir archivos
      async uploadFile(file) {
        try {
          let formData = new FormData();
          formData.append("file", file);
          let res = await axios.post(
            process.env.API_URL + "public/upload",
            formData
          );
          return res.data;
        } catch (error) {
          console.log(error);
        }
      },
      // Metodo para obtener destinatario de un determinado permiso
      async obtieneDestinatarioPermiso(id_permiso) {
        try {
          let respuesta = await this.graphql({
            query: `
            query{
                runQuery(consulta:"select control.fn_obtiene_destinatario_permiso(${parseInt(id_permiso)})"){
                  respuesta
                }
              }
            `
          });
          respuesta = respuesta.runQuery.respuesta[0].fn_obtiene_destinatario_permiso;
          return respuesta
        } catch (error) {
          console.log(error)
        }
      },
    };

    function parseErrorGraphql(data) {
      if (Util.toType(data.errors) === 'array') {
        let msg = [];
        data.errors.map(el => {
          if (el.message.indexOf('NOT_AUTHORIZED') !== -1) {
            if (el.message === 'NOT_AUTHORIZED:READ') {
              store.state.state403 = true;
              router.push('403');
            } else {
              Message.error('No tiene permisos para realizar esta operación.');
            }
          } else {
            let message = '<p>';
            if (el.name) {
              message += `<strong>Error: </strong>${el.name} <br />`;
            }
            message += `<strong>Mensaje: </strong> ${el.message}</p>`;
            msg.push(message);
          }
        });
        Message.error(msg.join(''));
      }
    }

    function _http(method, url, data) {
      instance.$Progress.start();
      url = getUrl(url, data);
      if (process.env.DEBUG_MODE) {
        console.group('Petición con DataService:');
        console.info('URL:', method.toUpperCase(), url);
        if (data) {
          console.info('Params:', data);
        }
      }

      let setting = {
        method,
        url
      };

      if (typeof data === 'object' && Object.keys(data).length) {
        delete data.id;
        setting.data = data;
      }

      // Set token in headers
      if (Storage.exist('token')) {
        setting.headers = { 'Authorization': `${authToken} ${Storage.get('token')}` };
      }

      return axios(setting)
        .then(response => filterResponse(response.data))
        .catch(error => handlingErrors(error));
    }

    function getUrl(url, id) {
      id = (typeof id === 'string' || typeof id === 'number') ? `${id}` : typeof id === 'object' && id.id ? `${id.id}` : '';
      if (url[url.length - 1] !== '/' && id.length > 1) {
        id = `/${id}`;
      }
      return PATERN_HOST.test(url) ? (url + id) : apiUrl + url + id;
    }

    function filterResponse(response) {
      instance.$Progress.finish();
      Loading.hide();
      let data = response.data || response.datos || response;
      if (process.env.DEBUG_MODE) {
        console.info('Respuesta:');
        if (Util.toType(data) === 'array') {
          if (window.navigator.appName === 'Netscape') {
            console.log('firefox');
            console.table(data);
          } else {
            console.table(data.map(item => [item]));
          }
        } else {
          console.dir(data);
        }
        console.groupEnd();
      }
      if (config && typeof config.filterResponse === 'function') {
        return config.filterResponse(response, Message);
      }
      if (data.error) {
        Message.error(data.error);
        return null;
      } else if (data.warning) {
        Message.warning(data.warning);
        return null;
      } else {
        return data;
      }
    }

    function handlingErrors(error) {
      instance.$Progress.fail();
      if (error.response) {
        let status = error.response.status;
        let data = error.response.data;
        let states = [401, 403, 500]; // Estados que no mostrarán mensajes

        if (states.indexOf(status) === -1) {
          if (status === 408 || status === 504) {
            return data;
          } else if (errorsLangEs[status]) {
            Message.error(parseError(data) || t('status') || t('unknown'));
          } else {
            Message.error(parseError(data) || t('unknown'));
          }
        }
      } else if (error.message) {
        if (error.message === 'Network Error') {
          Message.error(t('connection'));
        } else {
          Message.error(error.message);
        }
      } else {
        Message.error(t('unknown'));
      }
    }

    function parseError(data) {
      let message = 'mensaje';
      if (config && config.errorFormat) {
        message = config.errorFormat;
      }
      if (data[message]) {
        console.log('Error', data[message], Util.toType(data[message]));
        if (Util.toType(data[message]) === 'array') {
          let errors = [];
          data[message].map(el => {
            errors.push(el.error);
          });
          return errors.join('<br>');
        }
        return data[message];
      }
      return null;
    }

    // INTERCEPTORS CONFIG
    // Add a request interceptor
    axios.interceptors.request.use(function (config) {
      // Actualizando el tiempo de sesión de inactividad
      if (store.state.time) {
        store.commit('SET_TIME', process.env.TIME_SESSION_EXPIRED * 60);
      }
      return config;
    }, function (error) {
      return Promise.reject(error);
    });

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      Loading.hide();
      if (error.response) {
        if (error.response.status === 401) {
          if (window.location.hash !== '#/login') {
            Message.error(t('sessionExpired'));
            instance.logout(router, Loading);
          }
        }
        if (error.response.status === 403) {
          store.commit('setState403', true);
          router.push('/403');
        }
        if (error.response.status === 500) {
          let data = error.response.data;
          let message = null;
          if (process.env.DEBUG_MODE) {
            if (data.mensaje || data.message) {
              message = data.mensaje || data.message;
            } else if (typeof data === 'object') {
              let text = [];
              for (let key in data) {
                text.push(`${key}: ${data[key]}`);
              }
              message = text.join('<br />');
            }
          }
          store.state.message = message;
          router.push('/500');
        }
      }
      return Promise.reject(error);
    });

    Vue.prototype.$service = Services;
    Vue.prototype.$http = axios;
    Vue.prototype.$apiUrl = apiUrl;
    Vue.prototype.$authUrl = authUrl;
    Vue.prototype.$authToken = authToken;
  }
};



// WEBPACK FOOTER //
// ./src/common/plugins/service.js